/* eslint import/prefer-default-export: "off" */

export const transitionEndEventName = (() => {
  const b = document.body || document.documentElement;
  const s = b.style;
  const v = ['transition', 'WebkitTransition'];
  const e = ['transitionend', 'webkitTransitionEnd'];
  for (let i = 0; i < v.length; i += 1) {
    if (typeof s[v[i]] === 'string') {
      return {
        property: v[i],
        event: e[i],
      };
    }
  }
  return false;
})();

function convertUrl(src) {
  return $('<a>')
    .attr('href', src)
    .get(0).href;
}

function unique(array) {
  const storage = {};
  const uniqueArray = [];
  let i;
  let value;

  for (i = 0; i < array.length; i += 1) {
    value = array[i];
    if (!(value in storage)) {
      storage[value] = true;
      uniqueArray.push(value);
    }
  }
  return uniqueArray;
}

export function setLoadingEvent($container, callback) {
  const deferred = new $.Deferred();
  let imgs = [];
  let $img;

  function imgLoadCompleteCallback(files, completeCallback) {
    const fileLength = files.length;
    let completeCount = 0;
    const loadimg = file => {
      const $loadImage = $(new Image());

      $loadImage.one('load error', event => {
        $loadImage.off(event.type === 'load' ? 'error' : 'load');
        completeCount += 1;
        if (completeCount === fileLength) {
          completeCallback();
          deferred.resolve();
        }
      });
      $loadImage.attr('src', file);
    };

    if (fileLength === 0) {
      completeCallback();
      deferred.resolve();
    } else {
      for (let i = 0; i < fileLength; i += 1) {
        loadimg(files[i]);
      }
    }
  }

  if ($container.prop('tagName').toLowerCase() === 'img') {
    $img = $container;
  } else {
    $img = $container.find('img');
  }

  $container.add($container.find('*')).each((index, element) => {
    const $element = $(element);
    const imageList = [];

    imageList.push($element.css('background-image'));
    imageList.push(
      window
        .getComputedStyle($element[0], '::before')
        .getPropertyValue('background-image'),
    );
    imageList.push(
      window
        .getComputedStyle($element[0], '::after')
        .getPropertyValue('background-image'),
    );
    imageList.forEach(image => {
      if (image !== 'none') {
        $.each(image.match(/url\(.+?\)/g), (matchIndex, matchValue) => {
          let file = matchValue.replace(/(url\(|\)|")/g, '');

          if (file.indexOf('data') !== 0) {
            file = convertUrl(file);
            imgs.push(file);
          }
        });
      }
    });
  });
  $img.each((index, element) => {
    let file = $(element).attr('src');

    if (file.indexOf('data') !== 0) {
      file = convertUrl(file);
      imgs.push(file);
    }
  });
  imgs = unique(imgs);
  imgLoadCompleteCallback(imgs, callback);

  return deferred.promise();
}
